import { createFileRoute } from '@tanstack/react-router';
import { generateValidateSearch } from '@/lib/filters/validate-search';
import { VENDORS_ROUTE_CONFIG } from '@/pages/Providers/VendorsPage.config';

// The route declared no search params at all, because both filters lived in component state.
// Declaring them is what lets the page use navigate() rather than hold the term locally — an
// undeclared param is stripped on the next navigation.
export const Route = createFileRoute('/providers/')({
  validateSearch: generateValidateSearch(VENDORS_ROUTE_CONFIG),
});
